import { Link } from "react-router-dom";
import { useSiteCopy } from "../../context/SiteCopyContext";
import { CopyText } from "../CopyText";
import { getAtPath } from "../../lib/siteCopyPaths";

export function HomeDorothyTeaser() {
  const { copy } = useSiteCopy();
  return (
    <section className="section home-dorothy-teaser">
      <div className="home-teaser-grid">
        <div className="home-teaser-photo">
          <div className="home-teaser-photo-frame">
            <img
              src="/assets/poster.jpg"
              alt={String(getAtPath(copy, "home.dorothyTeaser.imageAlt") ?? "")}
            />
          </div>
          <div className="home-teaser-photo-glow" aria-hidden="true"></div>
        </div>
        <div className="home-teaser-text">
          <div className="sec-eyebrow">
            <em>
              <CopyText path="home.dorothyTeaser.eyebrow" as="span" />
            </em>
          </div>
          <h2 className="sec-title sec-title-sm">
            <CopyText path="home.dorothyTeaser.quote" as="span" />
          </h2>
          <p className="sec-lede" style={{ marginBottom: 28, opacity: 0.85 }}>
            <CopyText path="home.dorothyTeaser.body" as="span" />
          </p>
          <Link to="/dorothy" className="btn btn-primary">
            {String(getAtPath(copy, "home.dorothyTeaser.cta") ?? "")}{" "}
            <span className="arr">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
